import { FormInput } from "@/shared/ui/form-input"
import { Modal } from "@/shared/ui/modal"
import { closeCreateUserIntegrationModal, createUserIntegrationSchema, fetchCreateUserIntegration, selectIsCreateUserIntegrationModalOpen, selectOnCreate } from "../../model"
import { yupResolver } from "@hookform/resolvers/yup"
import { SubmitHandler, useForm } from "react-hook-form"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"

interface CreateUserIntegrationFormValues {
    callback_url: string
}

const initialState: CreateUserIntegrationFormValues = {
    callback_url: ""
}

export const CreateUserIntegrationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsCreateUserIntegrationModalOpen)
    const onCreate = useAppSelector(selectOnCreate)

    const handleClose = () => {
        dispatch(closeCreateUserIntegrationModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchCreateUserIntegration({
                callback_url: data.callback_url
            }))
                .unwrap()
                .then(() => {
                    notify.success('Пользовательская интеграция успешно создана')
                    reset()
                    onCreate?.()
                    handleClose()
                    res('')
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(createUserIntegrationSchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Создание <br />
                    Пользовательской <br />
                    Интеграции
                </div>
            )}
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label={"Адрес обратного вызова"}
                    id={"callback_url"}
                    error={errors['callback_url']}
                    required={true}
                    placeholder="Введите адрес обратного вызова"
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Добавить
                    </button>
                </div>
            </form>
        </Modal>
    )
}